import React, { useState } from 'react';
import JsonView from 'react18-json-view'
import 'react18-json-view/src/style.css'
import { Grid } from "@mui/material";
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableContainer from '@mui/material/TableContainer';
import TableBody from '@mui/material/TableBody';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import TablePagination from '@mui/material/TablePagination';
import Stack from '@mui/material/Stack';
import { UiButton } from '../../../_uiComponents/common/form/UiButton';

export default function JsonViewDataTable(props) {

    const [openList, setOpenList] = React.useState(false);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [active, setActive] = React.useState();


    const dataUploadHandle = (clickedIndex) => {
        if (active === clickedIndex) {
            setActive(null);
            setOpenList(true);
        } else {
            setActive(clickedIndex);
            setOpenList(true);
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const dataRows = [
        {
            id: 1,
            name: 'Sales type 1',
            type: 'abc',
            total_records: 10,
            in_use: true,
            enable: true,
            status: 'failed',
            items: [
                {
                    id: 1,
                    name: 'Sales 01',
                    customerId: '1984510',

                },
                {
                    id: 2,
                    name: 'Sales 02',
                    customerId: 'Anonymous',

                },
            ],

        },
        {
            id: 2,
            name: 'Sales type 2',
            type: 'abc',
            total_records: 10,
            in_use: true,
            enable: true,
            status: 'failed',
            items: [
                {
                    id: 1,
                    name: 'Sales 03',
                    customerId: '1984510',

                },
                {
                    id: 2,
                    name: 'Sales 04',
                    customerId: 'Anonymous',

                },
            ],

        },
    ]

    return (
        <>
            <Table sx={{ minWidth: 650, mt: 1 }}>
                <TableBody>
                    {dataRows.map((item, index) => (
                        <TableRow>
                            <TableCell style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: 0, paddingRight: 0, background: '#f9f8f8', border: 'none' }} colSpan={12}>
                                <div className="sba-data-upload-summary-records"
                                    onClick={() => { dataUploadHandle(index) }}
                                >
                                    <span className='sba-data-upload-name'>
                                        {active == index && openList ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                        {item.name}</span>
                                    <span className='sba-data-upload-status'>
                                        {item.status === 'success' ?
                                            <span className="sba-dataupload-file-success">Success</span> :
                                            <span className="sba-dataupload-file-failed">Failed</span>}
                                    </span>
                                </div>
                                <Collapse in={active == index && openList} timeout="auto" unmountOnExit>
                                    <Grid container spacing={2} >
                                        <Grid item xs={12} lg={6}>
                                            <div className='sba-upload-json-view'>
                                                <JsonView
                                                    src={item.items}
                                                    editable={{delete:false,edit:true}}
                                                    onEdit={params => {
                                                        console.log(params)
                                                    }} />
                                            </div>
                                        </Grid>
                                        <Grid item xs={12} lg={6} >
                                            <div className='sba-upload-error-list'>
                                                <h5>Error List</h5>
                                                <ul>
                                                    <li>Error 1</li>
                                                    <li>Error 11</li>
                                                    <li>Error 2</li>
                                                    <li>Error 3</li>
                                                </ul>
                                            </div>
                                        </Grid>

                                    </Grid>
                                    <Grid container sx={{ display: 'flex', textAlign: 'right', mt: 2, mb: 2 }} >
                                        <Grid item xs={12} lg={12} >
                                        <Stack spacing={2} direction="row" justifyContent="end" sx={{ width: '100%', mt: 3 }}>
                                            <UiButton name="Clear" variant="outlined" size="large" />
                                            <UiButton name="Process" variant="contained" size="large" />
                                        </Stack>
                                            
                                        </Grid>
                                    </Grid>

                                </Collapse>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25, 100]}
                component="div"
                count={dataRows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />


        </>
    )
}
